import React from 'react';
import autoBind from 'react-autobind';
import { Drawer, Row, Form, Select, Col, Button, Input, Table, Space, message } from 'antd';
import { PlusOutlined, DeleteOutlined, EditOutlined } from '@ant-design/icons';
import Utils from '../../../components/Utils';
import Globals from '../../../config/Globals';
import CustomComponent from '../../../components/CustomComponent';

export default class CommonCertificationTriggerStatesDrawer extends CustomComponent {
  constructor(props) {
    super(props);
    autoBind(this);
    this.state = {
      isVisible: false,
      trigger: null,
      index: -1,
      actions: [],
      newAction: { actionTriggerState: null, actionCommand: null, actionArguments: [] },
    };
  }

  show(trigger, index) {
    this.setState(
      {
        isVisible: true,
        trigger,
        index: index !== undefined ? index : -1,
        actions: trigger?.actions || [],
        newAction: { actionTriggerState: null, actionCommand: null, actionArguments: [] },
      },
      () => {
        if (trigger) this.form.setFieldsValue(trigger);
      }
    );
  }

  handleAddAction() {
    const { newAction, actions } = this.state;
    if (newAction.actionTriggerState && newAction.actionCommand && newAction.actionArguments.length > 0) {
      this.setState({
        actions: [...actions, newAction],
        newAction: { actionTriggerState: null, actionCommand: null, actionArguments: [] },
      });
    }
  }

  handleClose() {
    this.form.resetFields();
    this.setState({ isVisible: false, trigger: null, index: -1, actions: [] });
  }

  handleEditAction(index) {
    const actionToEdit = this.state.actions[index];
    const updatedActions = [...this.state.actions];
    updatedActions.splice(index, 1);
    this.setState({
      newAction: { ...actionToEdit },
      actions: updatedActions,
    });
  }

  async handleSubmit() {
    const formData = await this.form.validateFields();
    const finalData = { ...formData, actions: this.state.actions };
    this.props.onUpdate(finalData, this.state.index);
    this.handleClose();
  }

  handleDeleteAction(index) {
    const actions = [...this.state.actions];
    actions.splice(index, 1);
    this.setState({ actions });
  }

  render() {
    const { courses = [] } = this.props;
    const { newAction } = this.state;
    console.log('Courses:', courses);
    return (
      <Drawer
        open={this.state.isVisible}
        title={`${this.state.trigger ? 'Edit' : 'Create'} Certification Trigger`}
        placement="right"
        onClose={this.handleClose}
        width={800}
      >
        <Form layout="vertical" {...Utils.propagateRef(this, 'form')}>
          <Form.Item
            name="triggerType"
            label="Trigger Type"
            tooltip="Determines if this trigger applies to a new certification or during the renewal process."
            rules={[{ required: true }]}
          >
            <Select>
              {Object.entries(Globals.CertificationTriggerType).map(([value, label]) => {
                const isUsed = this.props.triggersTypes.includes(value);
                return (
                  <Select.Option key={value} value={value} disabled={isUsed && value !== this.state?.trigger?.triggerType}>
                    {label}
                  </Select.Option>
                );
              })}
            </Select>
          </Form.Item>

          <Form.Item name="webhook" label="Webhook" tooltip="URL to be invoked by LMS to check status of the student.">
            <Input />
          </Form.Item>

          <Form.Item
            name="defaultState"
            label="Default Value"
            tooltip="Value to be used if webhook fails or is not defined."
            rules={[{ required: true }]}
          >
            <Select>
              {Object.entries(Globals.CertificationTriggerState).map(([value, label]) => (
                <Select.Option key={value} value={value}>
                  {label}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>
          <Form.Item label="Actions" tooltip="Action to be triggered by states." style={{ marginLeft: 6 }} />
          <Row gutter={12} wrap={false} style={{ width: '100%' }}>
            <Col style={{ width: 160, display: 'flex', alignItems: 'flex-end' }}>
              <Form.Item style={{ width: '100%' }}>
                <Select
                  placeholder="State"
                  value={newAction.actionTriggerState}
                  onChange={(value) => this.setState({ newAction: { ...newAction, actionTriggerState: value } })}
                >
                  {Object.entries(Globals.CertificationTriggerState).map(([value, label]) => (
                    <Select.Option key={value} value={value}>
                      {label}
                    </Select.Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>

            <Col style={{ width: 180, display: 'flex', alignItems: 'flex-end' }}>
              <Form.Item style={{ width: '100%' }}>
                <Select
                  placeholder="Command"
                  value={newAction.actionCommand}
                  onChange={(value) => this.setState({ newAction: { ...newAction, actionCommand: value } })}
                >
                  {Object.entries(Globals.CertificationActionCommand).map(([value, label]) => (
                    <Select.Option key={value} value={value}>
                      {label}
                    </Select.Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>

            <Col style={{ width: 300, display: 'flex', alignItems: 'flex-end' }}>
              <Form.Item style={{ width: '100%' }}>
                <Select
                  mode="multiple"
                  placeholder="Courses"
                  value={newAction.actionArguments.length > 0 ? newAction.actionArguments : undefined}
                  onChange={(value) => this.setState({ newAction: { ...newAction, actionArguments: value } })}
                  allowClear
                >
                  {courses.map((course) => (
                    <Select.Option key={course.id} value={course.id}>
                      {course.displayName}
                    </Select.Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>

            <Col style={{ width: 48, display: 'flex', alignItems: 'flex-end' }}>
              <Form.Item style={{ marginBottom: 0 }}>
                <Button
                  type="primary"
                  icon={<PlusOutlined />}
                  disabled={
                    !newAction.actionTriggerState || !newAction.actionCommand || newAction.actionArguments.length === 0
                  }
                  onClick={this.handleAddAction}
                />
              </Form.Item>
            </Col>
          </Row>
          <Table
            dataSource={this.state.actions}
            rowKey={(record, index) => index}
            pagination={false}
            style={{ marginTop: 16 }}
            columns={[
              {
                title: 'State',
                dataIndex: 'actionTriggerState',
                key: 'actionTriggerState',
                render: (val) => Globals.CertificationTriggerState[val] || val,
              },
              {
                title: 'Command',
                dataIndex: 'actionCommand',
                key: 'actionCommand',
                render: (val) => Globals.CertificationActionCommand[val] || val,
              },
              {
                title: 'Courses',
                dataIndex: 'actionArguments',
                key: 'actionArguments',
                render: (courseIds) =>
                  courseIds.map((id) => courses.find((c) => c.id === id)?.displayName || id).join(', '),
              },
              {
                title: 'Actions',
                key: 'actions',
                render: (_, __, index) => (
                  <Space>
                    <Button
                      variant="none"
                      icon={<EditOutlined />}
                      shape="circle"
                      onClick={() => this.handleEditAction(index)}
                    />
                    <Button
                      style={{ marginLeft: 5 }}
                      variant="none"
                      icon={<DeleteOutlined />}
                      shape="circle"
                      onClick={() => this.handleDeleteAction(index)}
                    />
                  </Space>
                ),
              },

            ]}
          />

          <Row justify="end" style={{ marginTop: 24 }}>
            <Button style={{ marginRight: 8 }} onClick={this.handleClose}>
              Cancel
            </Button>
            <Button type="primary" onClick={this.handleSubmit}>
              Save
            </Button>
          </Row>
        </Form>
      </Drawer>
    );
  }
}
